import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, Loader2, ArrowRight } from "lucide-react";
import api from "../lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) {
      setStatus("error");
      return;
    }
    let attempts = 0;
    const timer = setInterval(async () => {
      attempts += 1;
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          clearInterval(timer);
        } else if (attempts >= 15) {
          setStatus("pending");
          clearInterval(timer);
        }
      } catch {
        if (attempts >= 15) {
          setStatus("error");
          clearInterval(timer);
        }
      }
    }, 2000);
    return () => clearInterval(timer);
  }, [sessionId]);

  return (
    <div data-testid="payment-success-page" className="min-h-screen grid place-items-center px-6">
      <motion.div
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
        className="max-w-md w-full text-center"
      >
        {status === "checking" && (
          <>
            <Loader2 size={40} className="animate-spin text-[#E05638] mx-auto" />
            <h1 className="font-display font-bold text-2xl mt-6">Conferma pagamento in corso…</h1>
            <p className="text-neutral-500 text-sm mt-3">Stiamo verificando il tuo pagamento con Stripe.</p>
          </>
        )}
        {status === "paid" && (
          <>
            <CheckCircle2 size={48} className="text-emerald-500 mx-auto" />
            <h1 className="font-display font-bold text-3xl mt-6">Benvenuto a bordo!</h1>
            <p className="text-neutral-600 text-sm mt-3 leading-relaxed">
              Pagamento confermato. Il tuo piano è attivo: il team ti contatterà entro 24 ore per
              il kickoff del progetto.
            </p>
            <Link
              to="/dashboard"
              data-testid="payment-success-dashboard-link"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#111111] text-white px-7 py-3.5 text-sm font-semibold hover:bg-[#E05638] transition-colors"
            >
              Vai alla tua area clienti <ArrowRight size={15} />
            </Link>
          </>
        )}
        {(status === "pending" || status === "error") && (
          <>
            <Loader2 size={40} className="text-neutral-400 mx-auto" />
            <h1 className="font-display font-bold text-2xl mt-6">Verifica in attesa</h1>
            <p className="text-neutral-600 text-sm mt-3 leading-relaxed">
              Il pagamento è in fase di conferma. Controlla la tua area clienti tra qualche minuto.
            </p>
            <Link
              to="/dashboard"
              className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#111111] text-white px-7 py-3.5 text-sm font-semibold hover:bg-[#E05638] transition-colors"
            >
              Vai alla dashboard <ArrowRight size={15} />
            </Link>
          </>
        )}
      </motion.div>
    </div>
  );
}
